import { WARNING_MESSAGE, AboutYouQuestionType } from '@acorn/util';

export const WARNING_MESSAGE_QUESTION_TYPE_MAP: Map<string, string> = new Map([
  [AboutYouQuestionType.AYCitizenshipStatus, WARNING_MESSAGE.RELATED_TO_ASSETS],
  [AboutYouQuestionType.AYInvestments, WARNING_MESSAGE.RELATED_TO_INVESTMENT],
]);
